module.exports = __webpack_public_path__ + "static/media/3.edaf8ea9.jpeg";